import {call, put, takeLatest} from "redux-saga/effects";
import {
    PUT_MIN_MAX_DURATIONS,
    GET_MIN_MAX_DURATIONS,
    SET_MIN_MAX_DURATIONS, SET_ERROR_MSG
} from "@actions/actionTypes";
import {PutResource, GetResource} from "../../utils/HttpUtil";
import {onError, safe} from "./handlerError";

function* putMinMaxDurations({body}) {
    const minMaxDurations = yield call(PutResource, `/rate/appconfigs`, body);
    yield put({
        type: SET_MIN_MAX_DURATIONS,
        minMaxDurations: minMaxDurations.data
    })
    yield put({type: SET_ERROR_MSG, data: {type: 'done', messages: "success"}})
}

function* getMinMaxDurations() {
    const minMaxDurations = yield call(GetResource, `/rate/appconfigs`);
    yield put({
        type: SET_MIN_MAX_DURATIONS,
        minMaxDurations
    })
}

function* settingsSaga() {
    yield takeLatest(PUT_MIN_MAX_DURATIONS, safe(onError, putMinMaxDurations));
    yield takeLatest(GET_MIN_MAX_DURATIONS, safe(onError, getMinMaxDurations));
}

export default settingsSaga